export class ModuleIcon {
    static Invoice = 'fa fas fa-fw fa-file-invoice-dollar';
    static SalesInvoice = 'fa fas fa-fw fa-file-invoice-dollar';
    static PurchaseOrder = 'fa fas fa-fw fa-file-invoice';
    static TravelApplication = 'fa fas fa-fw fa-passport';
    static Expenses = 'fa fas fa-fw fa-wallet';
    static GenericDocument = 'fa fas fa-fw fa-file';
    static InputDocument = 'fa fas fa-fw fa-book-spells';
    static SystemAdministration = 'fa fa-fw fa-cog';
    static Logs = 'fa fas fa-file-medical-alt';
    static Home = 'fa fas fa-fw fa-home';
}
